import React, { useContext, useCallback, useState, useEffect, useRef} from 'react';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { IDEContext } from '../SolvePage';
import problems_json from '../../../Data/Problems.json'
import { getStringLanguageNameByLanguageID } from '../../../Data/ProblemsMethod';
import Editor from '@monaco-editor/react';
import SettingsDropdown from './SettingsDropdown';
import LanguageDropdown from './LanguageDropdown';
import FetchStartingCode from '../../../ClientProblemRouter/fetchStartingCode';


import "./IDE.css"
import { languages } from 'prismjs';


export default function IDE({problemID, validLanguages, setSelectedLanguage, selectedLanguage}){

    const [, setIDEText] = useContext(IDEContext); 
    const [in_fullscreen_mode, set_in_fullscreen_mode] = useState(false);
    const [show_settings_dropdown, set_show_settings_dropdown] = useState(false);
    const [font_size, set_font_size] = useState(13)
    const [show_line_numbers, set_show_line_numbers] = useState(false)
    const [light_mode, set_light_mode] = useState(() => {
        if (sessionStorage.getItem("Light Mode") !== null) return sessionStorage.getItem("Light Mode") === "true";  // Was getting weird mount behavior (I think due to data race) and this fixes that
        return true; 
    });
    const settingsDropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check that the ref is not not null (redundant)
            // Then make sure we are not selecting the button itself
            if (settingsDropdownRef.current && !settingsDropdownRef.current.contains(event.target)) {
                set_show_settings_dropdown(false);
            }
        };
        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);


    // Check for cached values of settings dropdown 
    useEffect(() => {
        if(sessionStorage.getItem("Font Size") !== null){
            set_font_size(sessionStorage.getItem("Font Size"));
        }
        if(sessionStorage.getItem("Light Mode") !== null){
            set_light_mode(sessionStorage.getItem("Light Mode") === "true");
        }
        if(sessionStorage.getItem("Line Numbers") !== null){
            set_show_line_numbers(sessionStorage.getItem("Line Numbers") === "true");
        }

    }, []);


    // Maps given language to the name monaco ide know that lang by
    const monacoLangMap = {
        "C++":        "cpp",
        "C":          "c",
        "Java":       "java",
        "Python":     "python",
        "Scala":      "scala",
        "JavaScript": "javascript",
        "Bash":       "shell",
        "Rust":       "rust",
        "x86":        "asm",
        "Verilog":    "verilog",
      }



    const handle = useFullScreenHandle();


    const selected_problem =  problems_json.find(prob => {
        return prob.problem_id === problemID
    });
    // const path_to_staring_code = selected_problem.path_to_source_code;
    const [starting_code, set_starting_code] = useState("")



    

    useEffect(() => {
        const fetchStartingCode = async () => {
            try{

                const sessionSelectedLanguage = sessionStorage.getItem(problemID);

                if(sessionSelectedLanguage !== null){
                    selectedLanguage = Number(sessionSelectedLanguage)
                }

                const sessionCode = sessionStorage.getItem(problemID + selectedLanguage); 
                if(sessionCode !== null){
                    set_starting_code(sessionCode);
                    setIDEText(sessionCode);
                }
                else{
                    const code = await FetchStartingCode(problemID, selectedLanguage);
                    set_starting_code(code);
                    setIDEText(code); // This is a little tricky, ide has two ways of being. One where user sets code and the other where it is chagned automatically, we do both but it works so fuck it. 
                }
                
            
            } catch (err){
                console.log("Error in fetchStartingCode", err);
            }
        }


        fetchStartingCode();
    },[starting_code, selectedLanguage])


    // This function signature is defined in Monaco internals and the props must match
    const editorSupervisor = (text, event) => {
        sessionStorage.setItem(problemID + selectedLanguage, text); 
        setIDEText(text)
    }

    // const handleEditorMount = (editor, monaco) => {
    //     setIDEText(editor.getValue())
    // }

    const editorRef = useRef(null);
    const monacoRef = useRef(null);


    // tricky to get custom highlighting, https://stackoverflow.com/questions/66278203/how-to-set-multiline-rule-in-monaco-editor
    const handleEditorMount = (editor, monaco) => {

        editorRef.current = editor;
        monacoRef.current = monaco;

        // Define the custom theme
        monacoRef.current.editor.defineTheme("myCustomTheme", {
            base: light_mode ? "hc-black" : "vs",
            inherit: true,
            rules: [
                { token: "identifier", foreground: light_mode ?  "9CDCFE" : "000000" },
            ],
            colors: {}
            
        });

        // Apply the theme
        monacoRef.current.editor.setTheme("myCustomTheme");
        setIDEText(editorRef.current.getValue());
    };

    


    useEffect(() => {

        if (editorRef.current == null || monacoRef.current == null) return;

        // Define the custom theme
        monacoRef.current.editor.defineTheme("myCustomTheme", {
            base: light_mode ? "hc-black" : "vs",
            inherit: true,
            rules: [
                { token: "identifier", foreground: light_mode ?  "9CDCFE" : "000000" },
            ],
            colors: {}
        });

        // Apply the theme
        monacoRef.current.editor.setTheme("myCustomTheme");
        setIDEText(editorRef.current.getValue());

    },[light_mode])


    // Keep font size within bounds
    const handleFontSize = (newFontSize) => {if(newFontSize >= 7 && newFontSize <= 30) set_font_size(newFontSize)}


    return(
        <div className="monaco-ide">
        <FullScreen handle={handle} className='full-screen-ide-wrapper'>
            <div className='settings-top-bar-containter'>
                <button className='full-screen-button'
                    onClick={() => {
                        in_fullscreen_mode ? handle.exit() : handle.enter();
                        set_in_fullscreen_mode(!in_fullscreen_mode);
                    }}
                >
                    <svg 
                        className='full-screen-svg'
                        xmlns="http://www.w3.org/2000/svg" 
                        width="10" height="10"
                        viewBox="0 0 24 24"
                        >
                        {/* <!-- Black background --> */}
                        <rect width="24" height="24" fill="#000" />
                        {/* <!-- Grey, thin full-screen corners --> */}
                        <g stroke="#aaa" stroke-width="1" fill="none" stroke-linecap="butt" stroke-linejoin="miter">
                        {/* <!-- Top-left --> */}
                        <path d="M4 10 V4 H10" />
                        {/* <!-- Top-right --> */}
                        <path d="M14 4 H20 V10" />
                        {/* <!-- Bottom-right --> */}
                        <path d="M20 14 V20 H14" />
                        {/* <!-- Bottom-left --> */}
                        <path d="M10 20 H4 V14" />
                        </g>
                    </svg>
                </button>

                <div className='settings-gear-wrapper' ref = {settingsDropdownRef}>

                    <button className='settings-gear-button'
                        onClick={() => set_show_settings_dropdown(!show_settings_dropdown)}
                    >
                        <svg
                            className='gear'
                            xmlns="http://www.w3.org/2000/svg"
                            width="15" height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            >
                            <circle cx="12" cy="12" r="3"></circle>
                            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                        </svg>
                    </button>

                    <div className='settings-dropdown-wrapper'>
                        {show_settings_dropdown && 
                            <SettingsDropdown 
                                ref = {settingsDropdownRef}
                                setFontSize={handleFontSize} 
                                currFontSize={font_size}
                                setShowLineNumbers={set_show_line_numbers}
                                showLineNumbers={show_line_numbers}
                                lightMode={light_mode}
                                setLightMode={set_light_mode}
                            />
                        }
                    </div>

                    

                </div>

                <div className='language-dropdown-wrapper'>
                        
                    <LanguageDropdown
                        problemID={problemID}
                        validLanguage={validLanguages}
                        selectedLanguage={selectedLanguage}
                        setSelectedLanguage={setSelectedLanguage}
                    />
                </div>
            </div>

            <span className='ide-bottom-line'/>

            <Editor
                height="100%"        // <- let Monaco itself fill that flex:1 box
                width="100%"
                language={monacoLangMap[getStringLanguageNameByLanguageID(selectedLanguage)]}
                value={starting_code}
                options={{
                    scrollBeyondLastLine: false,
                    fontSize: font_size,
                    lineNumbers: show_line_numbers ? "on" : "off",
                    renderLineHighlight: 'none',
                    scrollbar: {
                        verticalScrollbarSize:   4,
                        verticalSliderSize:      4,
                    },
                    minimap: { 
                        enabled: false             //  disables the code overview on the right
                    },
                    renderIndentGuides: false,
                    padding: { top: 10 }
                }}
                onChange = {editorSupervisor}
                onMount  = {handleEditorMount}
            />
        </FullScreen>
        </div>
    );
}


